export const removeEmptyProperties = (object = {}, comparingPattern) =>
  Object.fromEntries(
    Object.entries(object).filter(
      ([_, value]) => value != null && value !== comparingPattern
    )
  );
